<script setup lang="ts">
  defineOptions({ name: 'CPDivider', inheritAttrs: false })

  import { computed } from 'vue'

  // External library imports
  import { HLDivider } from '@platform-ui/highrise'

  // Props definitions
  const props = defineProps({
    id: {
      type: String,
      required: false,
      default: undefined,
    },
    className: {
      type: String,
      required: false,
      default: '',
    },
    marginTop: {
      type: String,
      required: false,
      default: '16px',
    },
    marginBottom: {
      type: String,
      required: false,
      default: '16px',
    },
    vertical: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: '--cp-border-500',
    },
  })

  const dividerMarginStyles = computed(() => {
    return {
      '--n-divider-margin': props.marginTop + ' 0px ' + props.marginBottom + ' 0px',
      '--n-color': 'var(' + props.color + ')',
    }
  })
</script>

<template>
  <HLDivider
    v-bind="$attrs"
    :id="props.id"
    :vertical="props.vertical"
    :class="props.className"
    class="cp-divider"
    :style="dividerMarginStyles"
  >
    <slot />
  </HLDivider>
</template>
